export default __webpack_public_path__ + "static/media/VKOW_11_mos_MPOL.2d436ff2.wav";